import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { Heart } from '@one-thd/sui-icons';
import { IconButton } from '@one-thd/sui-atomic-components';
import { SharebeltContext } from '../../Sharebelt.context';

const ShareBeltFavorite = ({ disable }) => {

  const { itemId } = useContext(SharebeltContext);

  if (disable) {
    return null;
  }

  return (
    <AddToList
      itemId={itemId}
      quantity={1}
      CustomAddToListActionElement={({ onClick }) => (
        <IconButton
          ariaLabel="Add To List"
          size="large"
          icon={Heart}
          onClick={onClick}
        />
      )}
    />
  );
};

ShareBeltFavorite.displayName = 'ShareBeltFavorite';

ShareBeltFavorite.propTypes = {
  disable: PropTypes.bool,
};
ShareBeltFavorite.defaultProps = {
  disable: false,
};

ShareBeltFavorite.dataModel = extend({}, AddToList);

export default ShareBeltFavorite;